
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiGround3Off as ObiGround3OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-ground-3-off.js';
 
 
 

 
 export const ObiGround3Off = createComponent({
   react: React,
   tagName: 'obi-ground-3-off',
   elementClass: ObiGround3OffElement,
   events: {
     
   }
  });
 
 